import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';

export const DnDInsertFallback = () => {
  return (
    <Box height={80} mb="16" bgcolor="original.brand.quaternary" radius="l" />
  );
};
